<template>
  <GmapMap
      :center="center"
      :zoom="13"
      map-type-id="hybrid"
      style="width: 100%; height: 400px"
      @click="setPosition"
      :options="{
          styles: [
              { featureType: 'all', stylers: [{ visibility: 'off' }] },
              { featureType: 'road', stylers: [{ visibility: 'on' }] },
              { featureType: 'water', stylers: [{ visibility: 'on' }] },
              { featureType: 'landscape', stylers: [{ visibility: 'on' }] },
              { featureType: 'administrative', stylers: [{ visibility: 'on' }] },
          ],
          gestureHandling: 'cooperative',
        }"
  >
    <GmapMarker
        v-if="position"
        :position="position"
        :draggable="true"
        @dragend="setPosition"
    />
  </GmapMap>
</template>

<script>
export default {
  name: "MapPicker",

  props: {
    latitude: String,
    longitude: String,
  },

  computed: {
    position: function() {
      if (this.latitude && this.longitude) {
        return {
          lat: parseFloat(this.latitude),
          lng: parseFloat(this.longitude),
        };
      }
      return null;
    },
    center: function() {
      if (this.latitude && this.longitude) {
        return {
          lat: parseFloat(this.latitude),
          lng: parseFloat(this.longitude),
        };
      }
      return {
        lat: 48.940340739487645,
        lng: 16.73700009282884,
      };
    },
  },

  methods: {
    setPosition(evt) {
      console.log(evt.latLng.lat(), evt.latLng.lng());
      this.$emit('update:latitude', evt.latLng.lat().toString());
      this.$emit('update:longitude', evt.latLng.lng().toString());
    },
  },

}
</script>
